import "./style.scss";
import { useClickOutside } from "@hook";
import { useEffect, useRef, useState } from "react";

const AB_2613 = ({ id = "", data = [], title = "", onChange, disable = false, city = false, error, setError = () => {}, isEmpty = "", className = "", setTriggerIcon = () => {}, index }) => {
    const [open, setOpen] = useState(false);
    const [m, setM] = useState(false);

    const nodeRef = useRef();

    useClickOutside("id", nodeRef, () => setOpen(false));

    useEffect(() => {
        if (open) {
            setTriggerIcon((prev) => {
                return { ...prev, [index]: 2 };
            });
        } else {
            if (!m) {
                setTriggerIcon((prev) => {
                    return { ...prev, [index]: 0 };
                });
            } else {
                setTriggerIcon((prev) => {
                    return { ...prev, [index]: 3 };
                });
            }
        }
    }, [open, m, index, setTriggerIcon]);

    return (
        <div className={`ab-3274 select-ui ${disable ? " select-ui_disabled" : ""} ${error ? " select-ui_error" : ""} ${open ? " select-ui_open" : ""}${isEmpty ? " select-ui_empty" : ""} ${id} ${className}`} ref={nodeRef} key={id}>
            <div
                className="select-ui__trigger"
                onClick={
                    disable
                        ? () => {}
                        : () => {
                              setOpen(!open);
                              setError(false);
                          }
                }
            >
                <span className="select-ui__title" style={title !== "Выберите город" && !disable && !isEmpty ? { color: "#111111" } : { color: "#87898F" }}>
                    {title.length ? title : "Выберите город"}
                </span>

                <svg className="select-ui__arrow" style={open ? { transform: "rotate(180deg)" } : {}} width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.2458 0.290792C10.0584 0.104542 9.80498 0 9.5408 0C9.27661 0 9.02316 0.104542 8.8358 0.290792L5.2458 3.83079L1.7058 0.290792C1.51844 0.104542 1.26498 0 1.0008 0C0.736612 0 0.483161 0.104542 0.295798 0.290792C0.20207 0.383755 0.127675 0.494356 0.0769067 0.616216C0.026138 0.738075 0 0.868781 0 1.00079C0 1.1328 0.026138 1.26351 0.0769067 1.38537C0.127675 1.50723 0.20207 1.61783 0.295798 1.71079L4.5358 5.95079C4.62876 6.04452 4.73936 6.11891 4.86122 6.16968C4.98308 6.22045 5.11379 6.24659 5.2458 6.24659C5.37781 6.24659 5.50852 6.22045 5.63037 6.16968C5.75223 6.11891 5.86283 6.04452 5.9558 5.95079L10.2458 1.71079C10.3395 1.61783 10.4139 1.50723 10.4647 1.38537C10.5155 1.26351 10.5416 1.1328 10.5416 1.00079C10.5416 0.868781 10.5155 0.738075 10.4647 0.616216C10.4139 0.494356 10.3395 0.383755 10.2458 0.290792Z"
                        fill={open ? "#373CEB" : title !== "Выберите город" && !disable && !isEmpty ? "#111111" : "#87898F"}
                    />
                </svg>
            </div>

            <div className={`select-ui__dropdown ${open ? "select-ui__dropdown_visible" : ""}`}>
                {id === "filial" ? <div className="select-ui__description">{`Адреса в г. ${city.city} `}</div> : null}
                <div className="select-ui__scroll">
                    {data.map((m, idx) => (
                        <div
                            key={idx}
                            className="select-ui__option"
                            onClick={() => {
                                onChange(m, id);
                                setOpen(!open);
                                setM(m);
                            }}
                        >
                            {m.city ? m.city : m.name ? m.name : m.text}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AB_2613;
